import { css } from '@emotion/core'
import { ArrowCaret } from '@fs/zion-icon'
import { IconButton } from '@fs/zion-ui'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

export default function useResponsiveTableExpandAll(toggleExpandAll, allExpanded) {
  // These two use effects handle rendering the expand all button in the table header.
  // Zion renders an empty td in the table header to always ensure at least one element
  // is in the header. This adds the expand all button as a child of the td. While this is
  // not a clean solution, it seems to be the only one currently available within the
  // constraints of the Zion UI library, and can be easily refactored later if needed.
  const td = document.querySelector('thead tr td')
  useEffect(() => {
    const temp = document.createElement('div')
    temp.id = 'expandAllContainer'
    if (td) {
      td.appendChild(temp)
    }
    return () => {
      // Remove the created element when the component unmounts or td changes
      if (temp.parentNode) {
        temp.parentNode.removeChild(temp)
      }
    }
  }, [td])

  useEffect(() => {
    const expandAllContainer = document.querySelector('#expandAllContainer')
    if (expandAllContainer) {
      ReactDOM.render(
        <span
          css={css`
            margin-inline-start: -8px;
          `}
        >
          <IconButton
            id="expandAllButton"
            Icon={ArrowCaret}
            iconDirection={allExpanded ? 'up' : 'down'}
            onClick={toggleExpandAll}
          />
        </span>,

        document.querySelector('#expandAllContainer')
      )
    }
  }, [allExpanded, toggleExpandAll])
}
